import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";
import AlertService from "@/core/services/alert.service";
import router from '@/router'

// action types

export const PAGINATE_ALL_ROLES = "getPaginatedRoles";
export const ALL_ROLES = "getAllRoles";
export const FIND_BY_ROLE_NAME = "findByRoleName";
export const CREATE_ROLE_FORM = "createRoleForm";
export const DELETE_ROLE = "deleteRole";
export const GET_ROLE_DATA = "getRoleData";
export const CREATE_ROLE = "createRole";
export const UPDATE_ROLE = "updateRole";
export const ADD_USER_TO_ROLE = "addUserToRole";
export const DELETE_USER_FROM_ROLE = "deleteUserFromRole";
export const ADD_PERMISSION_TO_ROLE = "addPermissionToRole";
export const DELETE_PERMISSION_FROM_ROLE = "deletePermissionFromRole";


// mutation types

export const SET_PAGINATED_ROLES = "setPaginatedRoles";
export const SET_ALL_ROLES = "setAllRoles";
export const SET_ROLE_DATA = "setRoleData";
export const SET_ROLE_META = "setRoleMeta";
export const SET_ROLE_ERROR = "setRoleError";
export const SET_ROLE_LOADING = "setRoleLoading";
export const CLEAR_ROLE_ERROR = "clearRoleError";
export const SET_IS_DISABLED_ROLE = "setIsDisabledRole";


const state = {
    roles: [],
    paginatedRoles: [],
    role_data: {},
    meta_role : {
        totalPages: 0,
        total: 0,
        from: 0,
        to: 0,
    },
    errors: [],
    loading: false,
    isDisabled: false
    };

const getters = {
   
    paginateAllRoles(state) {
        return state.paginatedRoles;
    },

    allRoles(state) {
        return state.roles;
    },

    getRoleData(state) {
        return state.role_data;
    },

    meta_role(state) {
        return state.meta_role;
    },

    
};

const actions = {
 
    [PAGINATE_ALL_ROLES](context, payload) {
        context.commit(SET_IS_DISABLED_ROLE, false);
        context.commit(SET_ROLE_LOADING, true);
        JwtService.getToken();
        ApiService.setHeader();
        ApiService.get(`/roles?size=${payload.itemsPerPage}&page=${payload.pageNumber}&sortBy=${payload.sortBy}&sortDesc=${payload.sortDesc}&searchText=${payload.search}&check=${payload.x}`)
        .then(({ data }) => {
            
            if(data == 403) {
                context.commit(SET_ROLE_LOADING, false);
                router.push('nopermission');
            }
            else {
                context.commit(SET_PAGINATED_ROLES, data);
                context.commit(SET_ROLE_META, data);
                context.commit(SET_ROLE_LOADING, false);
            }
            
        })
        .catch(( response ) => {
            context.commit(SET_ROLE_LOADING, false);
            context.commit(SET_ROLE_ERROR, response.errors);
        });
        ;
        
    },

    [FIND_BY_ROLE_NAME](context, payload) {
        context.commit(SET_IS_DISABLED_ROLE, false);
        context.commit(SET_ROLE_LOADING, true);
        JwtService.getToken();
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.get(`/findByRoleName?searchText=${payload.searchText}&check=${payload.x}`)
            .then((response) => {
                resolve(response);
            })
        });
    },

    [ALL_ROLES]() {
        return new Promise(resolve => {
            ApiService.get('/rolesAll')
            .then((response) => {
                resolve(response);
            })
        });
    },

    [CREATE_ROLE_FORM](context) {
        context.commit(SET_ROLE_LOADING, false);
        context.commit(SET_ROLE_ERROR, false);
        context.commit(SET_IS_DISABLED_ROLE, false);
    },

    [GET_ROLE_DATA](context, payload) {
        context.commit(SET_IS_DISABLED_ROLE, true);
        context.commit(SET_ROLE_LOADING, true);
        context.commit(CLEAR_ROLE_ERROR);
        return new Promise(resolve => {
            ApiService.get(`/role/${payload.id}`)
            .then(( response ) => {
                if(response.data == 403) {
                    context.commit(SET_ROLE_LOADING, false);
                    router.push('/nopermission');
                }
                else {
                    context.commit(SET_ROLE_DATA, response.data);
                    context.commit(SET_ROLE_LOADING, false);
                    context.commit(SET_IS_DISABLED_ROLE, false);
                    resolve(response);
                }
            })
            .catch(({ response }) => {
                context.commit(SET_ROLE_LOADING, false);
                context.commit(SET_ROLE_ERROR, response.data.errors);
                context.commit(SET_IS_DISABLED_ROLE, true);
            });
        });
    },

    [CREATE_ROLE](context, payload) {
        context.commit(SET_ROLE_LOADING, false);
        context.commit(SET_IS_DISABLED_ROLE, true);
        context.commit(CLEAR_ROLE_ERROR);
        return ApiService.post("/role/store", payload.data)
        .then(( response ) => {
            if(response.data == 403) {
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde ekleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                context.commit(CLEAR_ROLE_ERROR);
            }
            else{
                context.commit(SET_ROLE_LOADING, false);
                AlertService.makeToast(
                    "success",
                    "Kayıt Başarılı",
                    "Kullanıcı rolü başarıyla kaydedilmiştir. ID numarası: " + response.data.id
                );
                context.commit(CLEAR_ROLE_ERROR);
                context.commit(SET_IS_DISABLED_ROLE, false);
                if(payload.goBack){
                    router.go(-1);    
                }
                return response;
            }
        })
        .catch(({ response }) => {
            context.commit(SET_ROLE_LOADING, false);
            context.commit(SET_ROLE_ERROR, response.data.errors);
            context.commit(SET_IS_DISABLED_ROLE, false);
            AlertService.makeToast(
                "danger",
                "Hata!",
                "Lütfen aşağıdaki hataları düzeltiniz veya eksiklikleri gideriniz."
            );
        });
    },

    [UPDATE_ROLE](context, payload) {
        context.commit(SET_ROLE_LOADING, true);
        context.commit(SET_IS_DISABLED_ROLE, true);
        context.commit(CLEAR_ROLE_ERROR);
        
        return ApiService.put(`/role/${payload.data.id}`, payload.data)
        .then((response) => {
            
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde güncelleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else{
                context.commit(SET_ROLE_LOADING, false);
                AlertService.makeToast(
                    "success",
                    "Güncelleme Başarılı",
                    payload.data.id + " ID numaralı kullanıcı rolü başarıyla güncellenmiştir."
                );
            
                context.commit(SET_IS_DISABLED_ROLE, false);
                if(payload.goBack){
                    router.go(-1);    
                }
                
            return response;   
            }
                
        })
        .catch(({ response }) => {
            context.commit(SET_ROLE_LOADING, false);
            context.commit(SET_ROLE_ERROR, response.data.errors);
            context.commit(SET_IS_DISABLED_ROLE, false);
            AlertService.makeToast(
                "danger",
                "Hata!",
                "Lütfen aşağıdaki hataları düzeltiniz veya eksiklikleri gideriniz."
            );
            
        });
        
    },

    [DELETE_ROLE](context, payload) {
        context.commit(SET_ROLE_LOADING, true);
        context.commit(CLEAR_ROLE_ERROR);
        JwtService.getToken();
        ApiService.setHeader();
        ApiService.delete(`/role/${payload.itemToDelete}`)
        .then(( response ) => {
            context.commit(SET_ROLE_LOADING, false);
            
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde silme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else{
                if(response.data == 401) {
                    AlertService.makeToast(
                        "warning",
                        "Silme Hatası",
                        "Silmeye çalıştığınız kullanıcı rolü login olmuş kullanıcıyla aynıdır. Silme başarısız."
                    );
                }
                else{
                    AlertService.makeToast(
                        "success",
                        "Silme Başarılı",
                        payload.itemToDelete + " ID numaralı kullanıcı rolü başarıyla silinmiştir."
                    );
                }
            }
        })
        .catch(( error ) => {
            context.commit(SET_ROLE_ERROR, error);
        });
        
    },

    [ADD_USER_TO_ROLE](context, payload) {
        ApiService.post("/role/addUser", payload.data)
        .then(( response ) => {
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde güncelleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else{
                AlertService.makeToast(
                    "success",
                    "Ekleme Başarılı",
                    "Kullanıcı başarıyla kullanıcı rolüne dahil edilmiştir."
                );
            }   
        })
       
    },

    [DELETE_USER_FROM_ROLE](context, payload) {
        ApiService.delete(`/role/deleteUser/${payload.data.role_id}/${payload.data.user_id}`)
        .then(( response ) => {
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde güncelleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else{
                AlertService.makeToast(
                    "success",
                    "Silme Başarılı",
                    "Kullanıcı başarıyla kullanıcı rolünden silinmiştir."
                );
            }   
        })
    },

    [ADD_PERMISSION_TO_ROLE](context, payload) {
        ApiService.post("/role/addPermission", payload.data)
        .then(( response ) => {
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde güncelleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else{
                AlertService.makeToast(
                    "success",
                    "Silme Başarılı",
                    "Kullanıcı rolü başarıyla izne dahil edilmiştir."
                );
            }   
        })
       
    },

    [DELETE_PERMISSION_FROM_ROLE](context, payload) {
        ApiService.delete(`/role/deletePermission/${payload.data.role_id}/${payload.data.permission_id}`)
        .then(( response ) => {
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde güncelleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else{
                AlertService.makeToast(
                    "success",
                    "Silme Başarılı",
                    "İzin başarıyla kullanıcı rolünden silinmiştir."
                );
            }   
        })
    },

    

 
    
};

const mutations = {

    [SET_PAGINATED_ROLES](state, paginatedRoles) {
        state.paginatedRoles = paginatedRoles.data;
    },

    [SET_ALL_ROLES](state, roles) {
        state.roles = roles;
    },

    [SET_ROLE_DATA](state, role_data) {
        state.role_data = role_data;
        state.errors = [];
    },

    [SET_ROLE_META](state, meta_role) {
        state.meta_role = meta_role;
    },

    [SET_ROLE_ERROR](state, error) {
        state.errors = error;
    },

    [CLEAR_ROLE_ERROR](state) {
        state.errors = [];
    },
    
    [SET_ROLE_LOADING](state, loading) {
        state.loading = loading;
    },

    [SET_IS_DISABLED_ROLE](state, isDisabled) {
        state.isDisabled = isDisabled;
    },

};

export default {
    state,
    actions,
    mutations,
    getters
};
